// combined lists below make the complete list of languages we currently support for detection
export const languagesWithSpaces: string[] = ['en', 'de', 'ru', 'fr', 'pt', 'cs', 'el'];
